module.exports = __webpack_public_path__ + "static/img/Tyrone-Munro.68aad1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tyrone-Munro.jpg
// module id = 69SL
// module chunks = 0